export default __webpack_public_path__ + "static/media/Compliance.2c238b33.png";